import { ButtonDestructive, ButtonStatus, ButtonTertiary } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { HTMLAttributes, useCallback } from "react"
import { usePilotTrackingConnectedAccountMutation } from "../usePilotTrackingConnectedAccountMutation"
import { ConfirmationModalProps } from "features/modals/WorkspaceConfirmationModalV2"
import * as Icons from "@nova/component-icons"
import { GlobalNotificationStatus } from "@nova/component-global-notification"

export const ConnectedAccountDeleteModal = ({
    confirm,
    cancel,
    isPerformingAsyncConfirmCallback: _,
    isPerformingAsyncCancelCallback: __,
    children,
    cacheKey,
    handleDelete,
    ...rest
}: ConfirmationModalProps &
    HTMLAttributes<HTMLDivElement> & {
        cacheKey: string
        handleDelete: () => void | Promise<void>
    }) => {
    const { trigger, isLoading } = usePilotTrackingConnectedAccountMutation({
        key: cacheKey,
        confirm,
        cancel,
        mutate: useCallback(async () => {
            await handleDelete()
        }, [handleDelete]),
        completionGlobalNotificationContext: {
            status: GlobalNotificationStatus.success,
            message: "Account disconnected.",
            timeoutInMs: 3000,
        },
        failureGlobalNotificationContext: {
            status: GlobalNotificationStatus.error,
            message: "Failed to disconnect account. Please try again.",
            timeoutInMs: 5000,
        },
    })

    return (
        <HighPriorityNovaModalContainer
            {...rest}
            title="Disconnect Account?"
            closeModal={cancel}
            className="w-[28rem]"
            bottomBar={
                <div className="flex ml-auto gap-2">
                    <ButtonTertiary title="Cancel" className="ml-auto" onClick={cancel} />
                    <ButtonDestructive
                        title="Disconnect Account"
                        onClick={() => trigger()}
                        status={isLoading ? ButtonStatus.Loading : ButtonStatus.Normal}
                        disabled={isLoading}
                        LeftIcon={Icons.LinkOff}
                    />
                </div>
            }
        >
            {children}
        </HighPriorityNovaModalContainer>
    )
}
